<template>
  <div class="content">
    <el-form
      :inline="true"
      :model="form"
    >
      <span style="color:red">*</span>
      <el-form-item :label="$t('lang.Card number')">
        <el-input maxlength="50" v-model="cardNo" :placeholder="$t('lang.Enter or read the card number')"
                  @input="cardNo = cardNo.replace(/[^\d]/g,'')" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="onsearch">{{ $t('lang.Inquire') }}</el-button>
    </el-form>
    <h3 class="h3">{{ $t('lang.User Info') }}</h3>
    <el-table
      class="mb20"
      ref="tableBattery"
      :data="tableInfoData"
      style="width: 100%"
    >
      <el-table-column prop="orderNo" :label="$t('lang.Order number')"></el-table-column>
      <el-table-column prop="uintName" :label="$t('lang.Organization')"></el-table-column>
      <el-table-column prop="cardNo" :label="$t('lang.Card number')"></el-table-column>
      <el-table-column prop="batteryStandards" :label="$t('lang.Current battery spec')">
        <template slot-scope="{row}">
          {{ $changeObj(BATTERY_TYPE)[row.batteryStandards] }}
        </template>
      </el-table-column>
      <el-table-column prop="surplusDays" :label="$t('lang.The remaining number of days')">
        <template slot-scope="{row}">
          {{ row.surplusDays }}{{ $t('lang.day') }}
        </template>
      </el-table-column>
      <el-table-column prop="surplusDays" :label="$t('lang.Available times')">
        <template slot-scope="{row}">
          {{ row.frequency || '--' }}
          <span v-if="row.frequency">{{ $t('lang.times') }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Effective time')">
        <template slot-scope="{row}" v-if="row.startTime">
          {{ $changeTime.showTime(Number(row.startTime), '', 0) }} -
          {{ $changeTime.showTime(Number(row.endTime), '', 0) }}
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="$t('lang.Username')"></el-table-column>
      <el-table-column prop="contactInfo" :label="$t('lang.User contact')"></el-table-column>
      <el-table-column prop="status" :label="$t('lang.Credential status')">
        <template slot-scope="{row}">
          {{ $t('lang.' + $changeObj(CARD_STATUS)[row.status]) }}
        </template>
      </el-table-column>

    </el-table>
    <div class="choose-card-type-title">
      <h3 class="h3 mr20">{{ $t('lang.Choose a package') }}</h3>
<!--      续费只能选择一种-->
<!--      <el-radio-group v-model="cardType" @change="selectTypeChange" v-if="rowBottom[0] && rowBottom[0].flag == 1">
        <el-radio-button label="1">{{ $t('lang.Measured card') }}</el-radio-button>
        <el-radio-button label="2">{{ $t('lang.Timer card') }}</el-radio-button>
      </el-radio-group>-->
    </div>
    <el-table
      class="mb20"
      @row-click="rowClick"
      highlight-current-row
      ref="table"
      :data="needShowData"
      style="width: 100%"
    >
      <el-table-column prop="commodityNo" :label="$t('lang.Product number')"></el-table-column>
      <el-table-column prop="name" :label="$t('lang.Product name')"></el-table-column>
      <el-table-column :label="$t('lang.Product types')">
        <template slot-scope="{row}">
          <div v-if="row.type == 15">{{ $t('lang.Measured card') }}</div>
          <div v-if="row.type == 4">{{ $t('lang.Timer card') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ratedVoltageStandard" :label="$t('lang.Battery spec')">
        <template slot-scope="{row}">
          {{ row.ratedVoltageStandard || 0 }}V
        </template>
      </el-table-column>
      <el-table-column prop="price" :label="$t('lang.Commodity price')"></el-table-column>
      <el-table-column :label="$t('lang.Quantity')">
        <template slot-scope="{row}" v-if="row.flag">
          <el-input-number v-model="form.cardQuantity" @change="handleCount" :min="1"
                           :label="$t('lang.Quantity')"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="timeLength" :label="$t('lang.Effective time')">
        <template slot-scope="{row}">
          {{ row.timeLength || 0 }}{{ $t('lang.day') }}
        </template>
      </el-table-column>
      <el-table-column prop="timeLength" :label="$t('lang.Available times')">
        <template slot-scope="{row}">
          {{ row.frequency || '--' }}
          <span v-if="row.frequency">{{ $t('lang.times') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <h3 class="h3 mb20">{{ $t('lang.Payment details') }}</h3>
    <el-divider></el-divider>
    <div class="mb20">
      <span class="mr20 ml24">{{ $t('lang.Rent') }}฿{{ rentMoney }}</span>
      <span class="mr20">{{ $t('lang.Number of replace ment cards') }}{{ form.cardQuantity }}</span>
      <span>{{ $t('lang.Total amount') }}฿{{ money }}</span>
    </div>
    <el-divider></el-divider>

    <el-button @click="cancelBtn">{{ $t('lang.Cancel') }}</el-button>
    <!-- 启动弹窗 -->
    <el-button @click="confirmBtn" type="primary">{{ $t('lang.Confirm') }}</el-button>

    <el-dialog
      :title="$t('lang.Renewal Details')"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <div class="content">
        <!-- 电池信息 -->
        <!-- <div class="detailBox">
            <p>{{$t('lang.Battery')}}</p>
            <el-table
            :data="rowTop"
            style="width: 100%">
                <el-table-column prop="commodityNo" :label="$t('lang.Battery Number')"></el-table-column>
                <el-table-column prop="ratedVoltageStandard" :label="$t('lang.Battery spec')">
                    <template slot-scope="{row}">
                        {{row.ratedVoltageStandard}}V
                    </template>
                </el-table-column>
                <el-table-column prop="date" :label="$t('lang.Commodity price')">
                    <template slot-scope="{row}">
                        ฿{{row.price}}
                    </template>
                </el-table-column>
                <el-table-column prop="date" :label="$t('lang.Deposit')">
                    <template slot-scope="{row}">
                        ฿{{row.deposit}}
                    </template>
                </el-table-column>
            </el-table>
        </div> -->
        <!--        <div class="detailBox">
                  <p>{{ $t('lang.Set meal') }}</p>
                  <el-table
                    :data="rowBottom"
                    style="width: 100%">
                    <el-table-column prop="orderNo" :label="$t('lang.Product number')"></el-table-column>
                    <el-table-column prop="uintName" :label="$t('lang.Product name')"></el-table-column>
                    <el-table-column prop="price" :label="$t('lang.Product types')">
                      <template slot-scope="{row}">
                        <div v-if="row.type == 15">{{ $t('lang.Measured card') }}</div>
                        <div v-if="row.type == 4">{{ $t('lang.Timer card') }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" :label="$t('lang.Commodity price')">
                      <template slot-scope="{row}">
                        ฿{{ rowTop[0].price }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('lang.Quantity')">
                      <template slot-scope="{row}">
                        {{ form.cardQuantity }}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('lang.Effective Total Time')">
                      <template slot-scope="{row}">
                        {{ row.surplusDays }} {{$t('lang.days')}}
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('lang.Available times')">
                      <template slot-scope="{row}">
                        {{ row.frequency || '&#45;&#45;' }}
                        <span v-if="row.frequency">{{ $t('lang.times') }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>-->
        <div class="detailBox">
          <p>{{ $t('lang.Userinfo') }}</p>
          <el-table
            :data="rowBottom"
            style="width: 100%">
            <el-table-column prop="cardNo" :label="$t('lang.Card number')"></el-table-column>
            <el-table-column :label="$t('lang.Battery spec')">
              <template slot-scope="{row}">
                <div>{{ rowTop[0].ratedVoltageStandard }}V</div>
              </template>
            </el-table-column>
            <el-table-column prop="surplusDays" :label="$t('lang.Effective time')"></el-table-column>
            <el-table-column prop="frequency" :label="$t('lang.Available times')">
              <template slot-scope="{row}">
                {{ row.frequency || '--' }}
                <span v-if="row.frequency">{{ $t('lang.times') }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Valid time')">
              <template slot-scope="{row}">
                {{ $changeTime.showTime(Number(row.startTime), '', 0) }} -
                {{ $changeTime.showTime(Number(row.endTime), '', 0) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Credential status')">
              <template slot-scope="{row}">
                {{ $t('lang.' + $changeObj(CARD_STATUS)[row.status]) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="detailBox">
          <p>{{ $t('lang.Package') }}</p>
          <el-table
            :data="[rowData]"
            style="width: 100%">
            <el-table-column prop="commodityNo" :label="$t('lang.Product number')"></el-table-column>
            <el-table-column prop="name" :label="$t('lang.Product name')"></el-table-column>
            <el-table-column prop="type" :label="$t('lang.Product types')">
              <template slot-scope="{row}">
                <div v-if="row.type == 15">{{ $t('lang.Measured card') }}</div>
                <div v-if="row.type == 4">{{ $t('lang.Timer card') }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label="$t('lang.Commodity price')">
              <template slot-scope="{row}">
                ฿{{ row.price }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Quantity')">
              <template slot-scope="{row}">
                {{ form.cardQuantity }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Effective Total Time')">
              <template slot-scope="{row}">
                {{ row.timeLength }} {{ $t('lang.days') }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.Available times')">
              <template slot-scope="{row}">
                {{ row.frequency || '--' }}
                <span v-if="row.frequency">{{ $t('lang.times') }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="detailBox">
          <p>{{ $t('lang.Amount') }}</p>
          <el-table
            :data="moneyTableData"
            style="width: 100%">
            <!-- <el-table-column prop="date" :label="$t('lang.Deposit')" >
                <template slot-scope="{row}">
                    ฿{{deposit}}
                </template>
            </el-table-column> -->
            <el-table-column prop="date" :label="$t('lang.Total Rent')">
              <template slot-scope="{row}">
                ฿{{ rentMoney }}
              </template>
            </el-table-column>
            <el-table-column prop="date" :label="$t('lang.Total amount')">
              <template slot-scope="{row}">
                ฿{{ money }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $t('lang.Cancel') }}</el-button>
                <el-button type="primary" @click="renewPay">{{ $t('lang.Confirm') }}</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>

import {renewPay, queryRenewPayCommodity} from '@/api/openCard';
import {BATTERY_TYPE, GOODS_TYPE, CARD_STATUS, commodity_Type_Code} from '@/utils/constant';

export default {
  data() {
    return {
      moneyTableData: [{}],
      renewPayFlag: true,
      commodity_Type_Code,
      CARD_STATUS,
      GOODS_TYPE,
      BATTERY_TYPE,
      rowData: '',
      cardNo: '',
      dialogVisible: false,
      card: '',
      form: {
        cardAccountNo: '',
        cardCommodityNo: '',
        cardQuantity: 0,
      },
      tableInfoData: [],
      tableData: [],
      rowTop: [],
      rowBottom: [],
      //换电卡类型，1次卡类型，2时卡类型
      cardType: '1',
    }
  },
  created() {
    // this.queryRegisterCardCommodity();
  },
  computed: {
    needShowData() {
      return this.tableData
      /*if (this.rowBottom[0] && this.rowBottom[0].flag == 2) {
        return this.tableData
      }
      return this.tableData.filter((el) => {
        return (el.type == 15 && this.cardType == 1) || (el.type == 4 && this.cardType == 2)
      })*/
    },
    rentMoney() {
      if (this.rowData.price) {
        return this.rowData.price * this.form.cardQuantity;
      }
      return 0;
    },
    money() {
      if (this.rowData.price) {
        return this.rentMoney + +this.rowData.deposit;
      }
      return 0;
    }
  },
  methods: {

    // 查询
    async onsearch() {
      this.form.cardQuantity = 0;
      this.rowTop = [];
      this.rowBottom = [];
      this.rowData = '';
      if (!this.cardNo) {
        this.$message.warning(this.$t('lang.Enter or read the card number'));
        return;
      }
      const params = {
        cardNo: this.cardNo
      };
      const res = await queryRenewPayCommodity(params);
      console.log(res, '查询返回');
      this.tableData = res.ldata;
      this.rowTop = res.ldata;//弹窗展示
      this.rowBottom = [res.mdata];//弹窗展示
      if (res.mdata.orderNo) {
        this.tableInfoData = [res.mdata];
      }
      //    tableBatteryData
    },
    cancelBtn() {
      this.$router.push('/managePage/warningRuleMgmt');
    },
    // 确定弹窗按钮
    confirmBtn() {
      console.log(this.rowData)
      if (!this.rowData) {
        this.$message.warning(this.$t('lang.Choose a package'));
        return;
      }
      this.dialogVisible = true;
    },
    //选择类型改变
    selectTypeChange() {
      this.rowData = ''
    },
    // 点table某行
    rowClick(row) {
      this.rowData = row;
      this.form.cardCommodityNo = row.commodityNo;
      this.form.cardAccountNo = this.cardNo;
      console.log(row, 'rowClick');
      this.tableData.forEach((el, i) => {
        el.flag = false;
      })
      row.flag = true;
      this.price = row.price;
      console.log(row, 'row');
    },
    // 计数器
    // handleChange(value) {
    //     console.log(value);
    // },
    // 确定（付款）
    async renewPay() {
      if (!this.renewPayFlag) {
        return;
      }
      this.renewPayFlag = false;
      const params = {
        ...this.form,
      };
      try {
        const res = await renewPay(params);
        console.log(res, '续费返回');
        if (res.result === 1) {
          this.dialogVisible = false;
          this.$message.success(this.$t('lang.Successful'));
          setTimeout(() => {
            this.$router.push('/managePage/warningRuleMgmt');
          }, 1000);
        }
      } catch (e) {
        console.log(e);
      }
      setTimeout(() => {
        this.renewPayFlag = true;
      }, 1000);

    }
  },
  components: {}
}
</script>

<style scoped>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-form-box {
  width: 300px;
}

.contentMsgBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detailBox {
  margin-bottom: 20px;
}

.choose-card-type-title {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/warningMgmt/alermRecord.vue